export default __webpack_public_path__ + "static/media/No.2-0.8a60e666.jpg";